import { render, staticRenderFns } from "./MyFaceberryEdit.vue?vue&type=template&id=a26ad4fa&scoped=true"
import script from "./MyFaceberryEdit.vue?vue&type=script&lang=js"
export * from "./MyFaceberryEdit.vue?vue&type=script&lang=js"
import style0 from "./MyFaceberryEdit.vue?vue&type=style&index=0&id=a26ad4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26ad4fa",
  null
  
)

export default component.exports